import React from 'react';
import { Card, Avatar, Tag } from 'antd';
import {
    MailOutlined,
    PhoneOutlined,
    CalendarOutlined,
    UserOutlined,
    HomeOutlined,
    TeamOutlined
} from '@ant-design/icons';
import { cn } from '../../../../../utils/cn';
import { getInitials } from '../../../../../utils/helper';
import { formatDateTime, formatLeadSource } from '../../../../../utils/functions';

const EnhancedLeadsImportedCardView = ({
    record,
    onCardClick,
}) => {
    const initials = getInitials(record.name);
    return (
        <Card
            hoverable
            className="h-full relative"
            onClick={() => onCardClick && onCardClick(record)}
        >
            <div className="space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3 overflow-hidden">
                        <Avatar
                            size={48}
                            className={cn("flex-shrink-0 font-semibold text-lg", record.originalData?.photo ? "" : "!bg-primary")}
                            src={record.originalData?.photo ?? ""}
                        >
                            {initials}
                        </Avatar>
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-base mb-1 truncate" title={record.name}>
                                {record.name || "N/A"}
                            </h3>
                            {record.userEmail && (
                                <p className="text-gray-500 text-sm mb-0 truncate" title={record.userEmail}>
                                    Client: {record.userEmail}
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                {/* Contact Info */}
                <div className="space-y-2 border-b border-gray-200 pb-3">
                    <div className="flex items-center text-sm text-gray-600">
                        <MailOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.email ?? "user-email"}>{record.email ?? "-"}</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-600">
                        <PhoneOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.phone ?? "user-phone"}>{record.phone ?? "-"}</span>
                    </div>
                    <div className="flex items-center text-sm text-gray-600">
                        <HomeOutlined className="mr-2 flex-shrink-0" />
                        <span className="truncate" title={record.address ?? "user-address"}>{record.address ?? "-"}</span>
                    </div>
                </div>

                {/* Event Details Section */}
                <div className="space-y-3">
                    {/* Lead Source */}
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            Lead Source:
                        </span>
                        <Tag color="blue" className="capitalize">
                            {record.leadSource}
                        </Tag>
                    </div>

                    {/* Event Name */}
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            Event:
                        </span>
                        <span className="text-sm text-gray-700 truncate max-w-[60%]" title={record.eventName}>
                            {record.eventName ?? "-"}
                        </span>
                    </div>

                    {/* Event Type */}
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            Event Type:
                        </span>
                        <span className="text-sm text-gray-700">
                            {record.eventType ?? "-"}
                        </span>
                    </div>

                    {/* Event Date */}
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            Event Date:
                        </span>
                        <span className="text-sm text-gray-700">
                            {record.eventDate ?? "-"}
                        </span>
                    </div>

                    {/* Guest Count */}
                    <div className="flex items-center justify-between">
                        <span className="text-sm text-gray-600 font-medium">
                            <TeamOutlined className="mr-1" />
                            Guest Count:
                        </span>
                        <span className="text-sm text-gray-700">
                            {record.guestCount ?? "-"}
                        </span>
                    </div>


                    {/* Imported At */}
                    <div className="flex items-center justify-between border-t border-gray-200 pt-3">
                        <span className="text-sm text-gray-600 font-medium">
                            <CalendarOutlined className="mr-1" />
                            Imported At:
                        </span>
                        <span className="text-sm text-gray-700">
                            {record.importedAt}
                        </span>
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedLeadsImportedCardView;